module.exports = __webpack_public_path__ + "static/media/d16ru.67be26db.pdf";